module.exports = __webpack_public_path__ + "img/item_icon7.72732601.png";